import { CustomPiece } from '../pieces/CustomPiece';
import { CrossPiece } from '../pieces/CrossPiece';
import { Plate } from '../pieces/Plate';
import { BeltRailJson } from '../Data';
import { PiecesList } from './PiecesList';
import { getPiecesData } from '../utils/dataStorage';
import { SimpleComponent } from '../pieces/SimpleComponent';
import { Position } from '../constants';
import { Rack } from './Rack';

export class Top extends Rack {
  constructor(
    crossPieces: CustomPiece<CrossPiece>[],
    plate?: CustomPiece<Plate>,
    glassPlate?: CustomPiece<Plate>,
    others?: CustomPiece<SimpleComponent>[],
  ) {
    super(0, 40, crossPieces, [], [], plate, glassPlate, others);
  }

  updateWidth(width: number) {
    super.updateWidth(width, true);
  }

  static fromModel(model: BeltRailJson, pieces?: PiecesList) {
    if (!pieces) pieces = getPiecesData();

    const crossPieces: CustomPiece<CrossPiece>[] = [];
    if (model.crossPieces) {
      for (const item of model.crossPieces) {
        crossPieces.push(
          CustomPiece.fromModel<CrossPiece>(item, pieces.crossPieces),
        );
      }
    }
    crossPieces.sort(CustomPiece.compareTo);
    let plate: CustomPiece<Plate> | undefined = undefined;
    let glassPlate: CustomPiece<Plate> | undefined = undefined;
    if (model.plate) {
      const plateType = Rack.getDefaultPlateType(
        Rack.acceptedPlatesTypes(
          crossPieces.find(e => e.position === Position.Front)?.base.type,
          crossPieces.find(e => e.position === Position.Back)?.base.type,
        ),
      );

      plate = CustomPiece.fromModel<Plate>(
        model.plate,
        pieces.plates,
        plateType,
      );

      if (model.glassPlate) {
        glassPlate = CustomPiece.fromModel<Plate>(
          model.glassPlate,
          pieces.plates,
          plateType,
        );
      }
    }

    return new Top(crossPieces, plate, glassPlate);
  }
}
